import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Container, makeStyles } from '@material-ui/core'

import { Header } from 'components'

import { Invoice } from '../Invoice'

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(10), // Add space for the header
  },
}))

export const Main: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <Header showBackButton={false} />
      <Container className={classes.container}>
        <Switch>
          <Route path="/invoice" component={Invoice} />
          <Route path="/" exact>
            <Redirect to="/invoice/menu" />
          </Route>
        </Switch>
      </Container>
    </>
  )
}
